import PropTypes from 'prop-types';

import { useAuth } from 'contexts/AuthContext';

import ProfileMenuDetails from './ProfileMenuDetails';

// ==============================|| HEADER PROFILE - PROFILE TAB ||============================== //

export default function ProfileTab({ onNavigate }) {
  const { user } = useAuth();

  return <ProfileMenuDetails user={user} onNavigate={onNavigate} showManageAccount />;
}

ProfileTab.propTypes = {
  onNavigate: PropTypes.func,
};
